export const ACTIONS = {
  GET_REFERENCE_BOOKS: 'reference-books/get-reference-books',
  SET_ERROR: 'reference-books/set-error',
  SET_LOADING: 'reference-books/set-loading',
  SET_REFERENCE_BOOKS: 'reference-books/set-reference-books',
};

export const FIELDS = {
  ACQUISITION_LIST: 'acquisitionList',
  CAR_ACQUISITION_TYPE_LIST: 'carAcquisitionTypeList',
  CAR_CONDITION_LIST: 'carConditionList',
  CHARACTER_POSITION_LIST: 'characterPositionList',
  CHARACTER_POSITIONS: 'characterPositions',
  COMPANY_COUNT_LIST: 'companyCountList',
  EDUCATION_LIST: 'educationList',
  EMPLOYER_INDUSTRY_BRANCH_LIST: 'employerIndustryBranchList',
  EMPLOYER_NEW_TYPE_LIST: 'employerNewTypeList',
  EMPLOYER_TYPE_LIST: 'employerTypeList',
  EMPLOYMENT_FORM_LIST: 'employmentFormList',
  EMPLOYMENT_TYPE_LIST: 'employmentTypeList',
  ERROR: Symbol('error'),
  FIO_CHANGE_REASONS_LIST: 'fioChangeReasonsList',
  GENDER_LIST: 'genderList',
  LEGAL_FORM_LIST: 'legalFormList',
  LOADING: Symbol('loading'),
  MARTIAL_STATUSES_LIST: 'martialStatusesList',
  POSITION_TYPE_LIST: 'positionTypeList',
  PROFIT_APPROVED_RUS_LIST: 'profitApprovedRusList',
  REALTY_OBTAINING_LIST: 'realtyObtainingList',
  REALTY_STATE_LIST: 'realtyStateList',
  REALTY_TYPE_LIST: 'realtyTypeList',
  ROLES_LIST: 'rolesList',
  SECOND_DOCUMENT_TYPES_LIST: 'secondDocumentTypesList',
  SOCIAL_STATUS_LIST: 'socialStatusList',
  SPOUSE_SOCIAL_STATUS_LIST: 'spouseSocialStatusList',
  TRUSTEE_RELATIONS: 'trusteeRelations',
  WORK_EXPIRIENCE: 'workExpirience',
};
